// extracted by mini-css-extract-plugin
module.exports = {"SubjectDropdown":"SubjectDropdown_SubjectDropdown__1WpZY","error":"SubjectDropdown_error__11_wd","label":"SubjectDropdown_label__KQHep","span":"SubjectDropdown_span__2_NLn"};